import React, { useState } from 'react';
import {
  // Accordion, AccordionDetails, AccordionSummary,
  Box, Container, Divider, Typography, styled
} from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
// import { getRandomStr } from '../../../../../helpers';
// import { withStyles } from '@mui/styles';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

const Accordion = styled(MuiAccordion)(({ theme }) => ({
  boxShadow: 'none',
  border: '1px solid #fff',
  borderRadius: '7px',
  '&:before': {
    display: 'none',
  },
  '&.MuiPaper-root.Mui-expanded': {
    borderRadius: '7px',
    border: '1px solid #eae9ee',
  },
}));

const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  // backgroundColor: '#fafafa',
  backgroundColor: '#fff',
  marginBottom: -1,
  minHeight: 52,
  '&.MuiAccordionSummary-root.Mui-expanded': {
    minHeight: 52,
    borderBottom: '1px solid #eae9ee',
    // backgroundColor: 'rgba(0, 0, 0, .03)',
    backgroundColor: '#FBFBFC',
    borderRadius: '6px 6px 0 0',
  },
  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: '12px 0',
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: '16px',
}));

const StockFAQs = ({ info, stock_faqs }) => {
  return (
    <>
      {stock_faqs && stock_faqs.length > 0 ?
        <Container maxWidth="xl" sx={{ py: '6rem', px: 0 }} itemScope itemType="https://schema.org/FAQPage">
          <Box component="div" className="w-100 text-center qna-center mt-5">
            <Box component="div" className="pb-5">
              <Typography component="h2" variant="h2" sx={{ fontWeight: 700, color: '#174c86', textAlign: 'center', fontSize: '1.5rem', pb: 4 }} itemProp="name">
                {`${info?.companyName} Frequently Asked Questions`}
              </Typography>
              <Divider sx={{ width: "15%", mx: 'auto', mb: 7 }} />
              <Box component="div" className="row qanda" sx={{}}>
                <Box component="div" className="col-md-6 text-left">
                  {/* <Grid container spacing={{ sm: 0, xs: 0, md: 2 }} sx={{}}>
                    <Grid size={{ md: 6 }}> */}
                  {stock_faqs && stock_faqs?.map((qa, ind) => {
                    return (qa.answer && qa.answer !== "" ?
                      <Accordion defaultExpanded itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
                        <AccordionSummary
                          aria-controls={`question${ind}-content`}
                          id={`question${ind}-header`}
                          expandIcon={<ExpandMoreRoundedIcon sx={{ color: '#174c86', }} />}
                        >
                          <Typography variant="p" component="h3" sx={{ lineHeight: 1.7, letterSpacing: '0.00938em', fontSize: '.95rem', color: '#174c86' }} className="font-weight-bold" dangerouslySetInnerHTML={{ __html: qa.question }} itemProp="name" />
                        </AccordionSummary>
                        <AccordionDetails itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
                          <Typography variant="p" component="p" sx={{ lineHeight: 1.7, letterSpacing: '0.00938em', fontSize: '.95rem', color: '#434166' }} dangerouslySetInnerHTML={{ __html: qa.answer }} itemProp="text" />
                        </AccordionDetails>
                        {/* <meta itemprop="dateModified" content={qa.updatedAt} /> */}
                      </Accordion> : null)
                  })}
                  {/* </Grid> */}
                  {/* <Grid size={{ md: 6 }}>
                      {stock_faqs && stock_faqs.slice(3, 6).map((qa, ind) => {
                        return (qa.answer && qa.answer !== "" ?
                          <Accordion defaultExpanded itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
                            <AccordionSummary
                              aria-controls={`question${ind}-content`}
                              id={`question${ind}-header`}
                              expandIcon={<ExpandMoreRoundedIcon sx={{ color: '#174c86', }} />}
                            >
                              <Typography variant="p" component="h3" sx={{ lineHeight: 1.7, letterSpacing: '0.00938em', fontSize: '.95rem', color: '#174c86' }} className="font-weight-bold" dangerouslySetInnerHTML={{ __html: qa.question }} itemProp="name" />
                            </AccordionSummary>
                            <AccordionDetails itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
                              <Typography variant="p" component="p" sx={{ lineHeight: 1.7, letterSpacing: '0.00938em', fontSize: '.95rem', color: '#434166' }} dangerouslySetInnerHTML={{ __html: qa.answer }} itemProp="text" />
                            </AccordionDetails>
                          </Accordion> : null)
                      })}
                    </Grid> */}
                  {/* </Grid> */}
                </Box>
              </Box>
            </Box>
          </Box>
          <meta itemprop="dateModified" content={stock_faqs[0]?.updatedAt} />
        </Container> : null}
    </>
  )
}

export default React.memo(StockFAQs)
